import EsusView from 'components/esus/EsusView'

export default function AvaliacaoElegibilidadeAdmissaoView() {
  return <EsusView url='/pec/user/relatorios/producao/analiticoAvaliacaoElegibilidade' />
}
